/* SUPPORT */
export const GET_SUPPORT = "GET_SUPPORT"
export const GET_SUPPORT_SUCCESS = "GET_SUPPORT_SUCCESS"
export const GET_SUPPORT_FAIL = "GET_SUPPORT_FAIL"

export const GET_SUPPORT_DETAILS = "GET_SUPPORT_DETAILS"
export const GET_SUPPORT_DETAILS_SUCCESS = "GET_SUPPORT_DETAILS_SUCCESS"
export const GET_SUPPORT_DETAILS_FAIL = "GET_SUPPORT_DETAILS_FAIL"

export const ADD_NEW_SUPPORT = "ADD_NEW_SUPPORT"
export const ADD_SUPPORT_SUCCESS = "ADD_SUPPORT_SUCCESS"
export const ADD_SUPPORT_FAIL = "ADD_SUPPORT_FAIL"

export const UPDATE_SUPPORT = "UPDATE_SUPPORT"
export const UPDATE_SUPPORT_SUCCESS = "UPDATE_SUPPORT_SUCCESS"
export const UPDATE_SUPPORT_FAIL = "UPDATE_SUPPORT_FAIL"

export const DELETE_SUPPORT = "DELETE_SUPPORT"
export const DELETE_SUPPORT_SUCCESS = "DELETE_SUPPORT_SUCCESS"
export const DELETE_SUPPORT_FAIL = "DELETE_SUPPORT_FAIL"

export const EXPORT_SUPPORT = "EXPORT_SUPPORT"
export const EXPORT_SUPPORT_SUCCESS = "EXPORT_SUPPORT_SUCCESS"
export const EXPORT_SUPPORT_FAIL = "EXPORT_SUPPORT_FAIL"

export const RESET_SUPPORT_STATE = 'RESET_SUPPORT_STATE';
export const RESET_SUPPORT_ATTACHMENT_STATE = 'RESET_SUPPORT_ATTACHMENT_STATE';
